export interface IUsersState {}

let usersState: IUsersState = {};

export default usersState;
